var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hs-loading"},[_c('span',{staticClass:"hs-loading-spinners",style:(_vm.style)},_vm._l((_vm.balde),function(item,index){return _c('i',{key:index,staticClass:"hs-loading-spinner"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }